
<!-- 根据区域检索摄像头 -->
<template>
  <div class="app-area-list">
    <div class="search-box">
      <el-input
        v-model="searchDevice"
        clearable
        prefix-icon="el-icon-search"
        :placeholder="$t('business.placeholder.keyword')"
      >
      </el-input>
    </div>
    <div class="area-container" ondragstart="return false">
      <el-scrollbar ref="scrollBar" class="scroll-bar">
        <el-tree
          class="full-height"
          ref="appAreaTree"
          :data="dataList"
          node-key="id"
          :props="defaultProps"
          :show-checkbox="multiCheck"
          highlight-current
          :default-expanded-keys="expandedKeys"
          :default-checked-keys="defaultCheckedKeys"
          :filter-node-method="filterNode"
          @check="checkChange"
        >
          <div
            unselectable="on"
            onselectstart="return false;"
            style="-moz-user-select: none"
            class="node"
            :title="data.name"
            slot-scope="{ data }"
          >
            <img
              v-show="data.nodeType === 'workgroup'"
              class="icon"
              src="@src/common/assets/images/peopleGroup.png"
              alt=""
            />
            <i
              v-show="data.nodeType === 'security'"
              class="el-icon-user-solid icon"
            ></i>
            <span>{{ data.name }}</span>
          </div>
        </el-tree>
      </el-scrollbar>
    </div>
  </div>
</template>
<script>
import { Cache } from "$utils";
export default {
  props: {
    multiCheck: {
      type: Boolean,
      default: false,
    },
    showPercentage: {
      type: Boolean,
      default: true,
    },
    defaultCheckedKeys: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  watch: {
    searchDevice(val) {
      this.$refs.appAreaTree.filter(val);
    },
  },
  data() {
    return {
      dataList: [],
      defaultProps: {
        children: "children",
        label: "name",
        id: "id",
      },
      searchDevice: "",
      cameraData: [],
      searchDeviceChange: false,
      // 默认展开的数组
      expandedKeys: [],
    };
  },
  mounted() {
    this.queryDevice();
  },
  methods: {
    filterNode(value, data) {
      if (!value) {
        return true;
      }
      return data.name.indexOf(value) !== -1;
    },
    // 查询区域树
    queryDevice() {
      this.$fetch("/cms/workgroup/querySecurityWorkGroupTree.json").then(
        (response) => {
          if (!response.success) {
            this.$message.error(response.msgContent);
            return;
          } else {
            let result = response.returnObj;
            this.expandedKeys = [result[0].id];
            this.dataList = result;
          }
        }
      );
    },
    // 多选
    checkChange(node, checkData) {
      console.log("选中节点", node);
      // 当前被选中节点
      let checkNodes = checkData.checkedNodes;
      this.checkedArea = [];
      this.checkedDevice = [];
      checkNodes.forEach((item) => {
        if (item.nodeType != "workgroup") {
          this.checkedDevice.push(item);
        } else {
          this.checkedArea.push(item);
        }
      });
      this.cameraData = this.checkedDevice;
      this.$emit("groupData", this.checkedDevice, this.checkedArea);
    },
    setChecked(deviceId) {
      this.$refs.appAreaTree.setCheckedKeys(deviceId);
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~@src/common/assets/style/mixin";
.app-area-list {
  height: 400px;
  overflow-y: hidden;
  display: flex;
  flex-direction: column;

  .search-box {
    margin-bottom: 10px;
  }
  .icon {
    margin: 0 5px 0 0;
    color: #3e76e6;
    font-size: 16px;
  }
  // .showDrag {
  //   cursor: move;
  // }
  .node {
    position: relative;
    display: flex;
    width: 100%;
    .node-cover {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }

    .camera-type-icon {
      text-align: right;
      flex: 1;
      margin-right: 10px;
    }
  }
  .area-container {
    flex: 1;
    overflow: hidden;

    .area-node-icon {
      margin-right: 5px;
    }
    .iconfont-lunan {
      margin-right: 5px;
    }
  }
  .scroll-bar {
    height: 100%;
    z-index: 1;
    .full-height {
      padding: 10px 0;
      :deep .el-tree-node__content {
        height: 30px;
        &:hover {
          @include set_theme_color(background-color, item-active-bg-color);
        }
      }
    }
    .el-scrollbar__wrap {
      overflow-x: hidden;
      height: 100%;
      margin-bottom: 0px !important;
    }
  }
}
</style>


